import $ from 'jquery';
import { createPopper } from '@popperjs/core';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow.js';
import scrollService from '../core/ScrollService.js';
const initInformationPopin = () => {
    const popinStorageKey = 'popinExpiryTime';
    const twoHoursInMillis = 2 * 60 * 60 * 1000;

    const storedExpiryTime = localStorage.getItem(popinStorageKey);
    const now = new Date().getTime();

    if (storedExpiryTime && now < storedExpiryTime) {
        return;
    }

    if (document.querySelector('.redirectPopin_item') && document.querySelector('.redirectPopin.info')) {
        let popinRedirect = document.querySelector('.redirectPopin.info');
        let redirectElt = document.querySelector('.redirectPopin_item');

        popinRedirect.classList.add('visible');
        redirectElt.classList.add('visible');
        scrollService.stop();

        const newExpiryTime = new Date().getTime() + twoHoursInMillis;
        localStorage.setItem(popinStorageKey, newExpiryTime);

        let closeElements = [
            popinRedirect.querySelector('.redirectPopin_background'),
            popinRedirect.querySelector('.redirectPopin_close'),
        ];
        closeElements.forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                scrollService.start();
                popinRedirect.classList.remove('visible');
            });
        });
    }
};

export { initInformationPopin };
